import React from 'react';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--c-bg)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '48px 24px',
      backgroundImage: `
        radial-gradient(ellipse 70% 60% at 50% -10%, rgba(0,200,150,0.12) 0%, transparent 60%),
        radial-gradient(ellipse 40% 40% at 80% 90%, rgba(141,198,63,0.06) 0%, transparent 50%)
      `,
    }}>
      <div style={{ maxWidth: 420, width: '100%', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
            <img src="/halvecost-logo.png" alt="WNLeads PRO" style={{ height: 48, width: 48, objectFit: 'contain' }} />
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: 26, lineHeight: 1 }}>
                <span style={{ color: 'var(--c-primary)' }}>WNLeads</span>
                <span style={{ color: 'var(--c-accent)' }}> PRO</span>
              </div>
              <div style={{ color: 'var(--c-text-3)', fontSize: 10, letterSpacing: '0.5px', textTransform: 'uppercase', marginTop: 3 }}>
                by WriteNow Agency
              </div>
            </div>
          </div>
          <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 24, color: 'var(--c-text)', marginBottom: 6 }}>
            {title}
          </h2>
          {subtitle && (
            <p style={{ color: 'var(--c-text-2)', fontSize: 14 }}>
              {subtitle}
            </p>
          )}
        </div>

        <div style={{
          background: 'var(--c-auth-card)',
          border: '1px solid var(--c-border)',
          borderRadius: 20,
          padding: 36,
          backdropFilter: 'blur(20px)',
          boxShadow: 'var(--shadow-elevated)',
        }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
